import React from "react";
import Styles from './styles.module.scss'

import Seo from "../../components/_UI/seo";
import {useTranslation} from "react-i18next";
import WpS1 from "../../components/wpS1";
import WpList from "../../components/wpList";




const WhitePaperPage = () => {
    const { t } = useTranslation();

    return (
        <section className={`${Styles.container}`}>
            <Seo title={t('White Paper')}/>
            <WpS1/>
            <WpList/>
        </section>
    );
};

export default WhitePaperPage;